var map = {
	"./constant": 1375,
	"./constant.ts": 1375,
	"./en": 82420,
	"./en.ts": 82420,
	"./ko": 11833,
	"./ko.ts": 11833,
	"./th": 53798,
	"./th.ts": 53798,
	"./type": 52112,
	"./type.ts": 52112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1431;